import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import type { GetGeneralSettingsQuery, UpdateGeneralSettingsMutation, UpdateGeneralSettingsMutationVariables } from '../../../types/gql-backend';

const UPDATE_GENERAL_SETTINGS = gql`
  mutation UpdateGeneralSettings($settings: GeneralSettingsChangeInput!) {
    updateGeneralSettings(settings: $settings) {
      pluginVersion
      DEPLOYMENT_ENVIRONMENT
    }
  }
`;

export default function PluginVersionEdit({ data }: { data: GetGeneralSettingsQuery }) {
  const { pluginVersion: initialPluginVersion, DEPLOYMENT_ENVIRONMENT } = data.generalSettings;
  const [pluginVersion, setPluginVersion] = useState(initialPluginVersion);
  const [versionExists, setVersionExists] = useState(true);
  const [updateGeneralSettings] = useMutation<UpdateGeneralSettingsMutation, UpdateGeneralSettingsMutationVariables>(UPDATE_GENERAL_SETTINGS);

  const verifyTaxiPluginVersionExist = async () => {
    const checkURL = `https://corp-mktg.s3.amazonaws.com/taxi/${DEPLOYMENT_ENVIRONMENT}/plugin/${pluginVersion}/lead.form.plugin.js`;
    try {
      const response = await fetch(checkURL);
      setVersionExists(response.ok);
      return response.ok;
    } catch (error) {
      setVersionExists(false);
      return false;
    }
  };

  const onSaveSettings = async () => {
    const versionExist = await verifyTaxiPluginVersionExist();
    if (!versionExist) {
      // TODO: Implement NotificationEngine without Saga
      // eslint-disable-next-line no-alert
      alert('Plugin version does not exist');
      return;
    }
    try {
      await updateGeneralSettings({ variables: { settings: { pluginVersion } } });
      // eslint-disable-next-line no-alert
      alert('Settings updated successfully');
    } catch (error) {
      if (error instanceof Error) {
        // eslint-disable-next-line no-alert
        alert(`Error updating settings: ${error.message}`);
      }
    }
  };

  const onPluginVersionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPluginVersion(e.target.value);
  };

  const border = versionExists ? 'border-success' : 'border-danger';

  return (
    <div className="container">
      <div className="row mt-4">
        <div className="col-6">
          <label
            htmlFor="general-settings-plugin-version"
            className="font-weight-bold text-uppercase"
          >
            Taxi Plugin Version ({DEPLOYMENT_ENVIRONMENT})
          </label>
          <small className="d-block">Sets the default version of the plugin to be used on form previews.</small>
          <input
            id="general-settings-plugin-version"
            type="text"
            className={`form-control mt-2 ${border}`}
            value={pluginVersion}
            onChange={onPluginVersionChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-3">
          <button
            type="button"
            id="general-settings-save-button"
            className="btn btn-primary btn-block"
            onClick={onSaveSettings}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

